import { combineReducers } from 'redux';

import feedPost from './feedPost.reducer';

export default combineReducers({
  postFeed: feedPost,
});